angular.module('NumbersEditor').controller('NewGameController', [
    '$scope', 'NewGameFactory', '$location', '$rootScope', 'PublishGameFactory', 'authFactory', '$document', '$routeParams', '$dialogs', '$modal', 'appInfoFactory',
    function ($scope, newGameFactory, $location, $rootScope, publishGameFactory, authFactory, $document, $routeParams, $dialogs, $modal, appInfoFactory) {

        function init() {
            $rootScope.SetAppTitle("New Game", "Add Games");
            $scope.isAdmin = authFactory.GetAuthenticationData().isAdmin;
            $scope.SportCodes = undefined;

            appInfoFactory.getDateTime()
                .success(function (dateTime) {
                    var today = new Date(JSON.parse(dateTime));
                    $scope.newGame = {
                        StartDate: $routeParams.date == undefined ? today : new Date($routeParams.date),
                        SportCode: undefined
                    };
                    $scope.minDate = new Date(today.getTime());
                    if ($scope.isAdmin === false) {
                        var todaysDate = new Date(today.getTime());
                        $scope.maxDate = today;
                        $scope.maxDate.setDate(todaysDate.getDate() + 8);
                    }
                }).error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        function searchGamesByDate() {
            $scope.SportCodes = undefined;
            $scope.newGame.SportCode = undefined;
            newGameFactory.checkGameByDate($scope.newGame.StartDate)
                .success(function (data) {
                    for (var i = 0; i < data.length; i++) {
                        data[i]["Class"] = "list-group-item Game-" + data[i].Status;
                    }
                    $scope.SportCodes = data;
                    $scope.selectGame($scope.SportCodes[0]);
                })
                .error(function (ex) {
                    $.message(ex.ExceptionMessage, MessageType.Error);
                });
        };

        init();

        $scope.AddEvent = function () {
            var newEvent = newGameFactory.AddEvent($scope.newGame.Events.length);
            $scope.newGame.Events.push(newEvent);
        };

        $scope.DeleteEvent = function (index) {
            $scope.newGame.Events.splice(index, 1);
        };

        $scope.AddGame = function () {
            for (var i = 0; i < $scope.newGame.Events.length; i++) {

                var eTime = new Date(1970, 0, 1);
                eTime.setHours($scope.newGame.Events[i].EventTime.split(":")[0]);
                eTime.setMinutes($scope.newGame.Events[i].EventTime.split(":")[1]);
                eTime.setSeconds("00");
                $scope.newGame.Events[i].EventTime = eTime.getTime();
            }

            newGameFactory.insertGame($scope.newGame)
                .success(function () {
                    $.message(MessageText.GameSuccessfullySaved, MessageType.Success);
                    searchGamesByDate();
                })
                .error(function (ex) {
                    $.message(ex.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.$watch('newGame.StartDate', function () {
            searchGamesByDate();
        });

        $scope.selectGame = function (sportCode) {

            for (var i = 0; i < $scope.SportCodes.length; i++) {
                if ($scope.SportCodes[i].SportCode != sportCode.SportCode) {
                    $scope.SportCodes[i].Class = "list-group-item Game-" + $scope.SportCodes[i].Status;
                }
            }

            if (sportCode.Status == "Available") {
                $scope.newGame.SportCode = sportCode.SportCode;
                sportCode.Class += " active";
                $scope.BindEvents();
            }
        };

        $scope.BindEvents = function () {
            newGameFactory.newGame($scope.newGame.SportCode, $scope.newGame.StartDate)
                .success(function (events) {
                    var eventsArray = [];
                    for (var i = 0; i < events.length; i++) {
                        var eTime = new Date(1970, 0, 1);
                        eTime.setTime(events[i].EventTime);

                        eventsArray.push({
                            EventNumber: events[i].RefId,
                            EventTime: eTime.getHours() + ':' + eTime.getMinutes(),
                            Status: "I"
                        });
                    }
                    $scope.newGame.Events = eventsArray;
                })
                .error(function (ex) {
                    $.message(ex.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.PublishGame = function (sportcode) {
            publishGameFactory.PublishGame(sportcode.Id)
                .success(function (game) {
                    $.message(MessageText.GameSuccessfullyPublished, MessageType.Success);
                    sportcode.PublicationStamp = game.PublicationStamp;
                    sportcode.CanPublish = game.CanPublish;
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.ManageGame = function (sportcode) {
            $location.path('game/' + sportcode.Id);
        };

        $document.bind('keypress', function ($event) {
            if ($event.which === 13) {
                $("#btnnewgamedate").click();
            }
        });

        // disabled the Christmas day in the calendar
        $scope.disabled = function (date, mode) {
            if (date.getMonth() == 11 && date.getDate() == "25") return true;
            else return false;

        };

        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.opened = true;
        };
    }
]);